import React, {useCallback, useRef, useState} from 'react';
import {IconButton, WithTooltip} from '@albert-io/atomic';
import type {WithTooltipHandle} from '@albert-io/atomic/molecules/Tooltip/Tooltip.react';

import {IssuesModal} from './IssuesModal';

interface Props {
  questionId: string;
}

export const IssuesModalButton = ({questionId}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const tooltip = useRef<WithTooltipHandle | null>(null);

  const onClick = useCallback(() => {
    if (tooltip.current) {
      tooltip.current.deactivate();
    }
    setIsOpen(true);
  }, [setIsOpen]);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  return (
    <>
      <WithTooltip ref={tooltip} content='Question Feedback'>
        <IconButton
          icon={['far', 'message-question']}
          onClick={onClick}
          label='Question Feedback'
        />
      </WithTooltip>
      {isOpen && <IssuesModal questionId={questionId} handleClose={handleClose} />}
    </>
  );
};
